<div
  id="c_{{ componentKey }}"
  *ngIf="otpForm?.controls"
  [ngStyle]="config.containerStyles"
  class="ng-otp-input-wrapper flex wrapper justify-content-center {{ config.containerClass }} text-center"
>
  <input
    id="otp_{{ i }}_{{ componentKey }}"
    #inp
    (input)="onInput($event)"
    (keydown)="onKeyDown($event)"
    (keyup)="onKeyUp($event, i)"
    (paste)="handlePaste($event)"
    *ngFor="let item of getKeys(otpForm?.controls); let i = index"
    [formControl]="otpForm.controls[item] | abstractToFormControl"
    [ngStyle]="config.inputStyles"
    [pattern]="config.allowNumbersOnly ? '\\d*' : ''"
    [placeholder]="config?.placeholder || ''"
    [type]="inputType"
    appNoLeadingSpace
    autocomplete="one-time-code"
    class="otp-input {{ config.inputClass }}"
  />
</div>

<div id="fake-focus"></div>
